<template>
  <!-- <el-container>
    <el-header> -->
      <div>
      <headerd></headerd>

      <goods></goods>

        <bottom></bottom>
        <car></car>
      </div>
    <!-- </el-header>
    <el-main> -->
    <!-- </el-main>
    <el-footer> -->
      
    <!-- </el-footer>
  </el-container> -->
</template>

<script>
import bottom from "components/common/bottom.vue";
import headerd from "components/common/header.vue";
import goods from "components/goods.vue";
import car from "components/carshop.vue";


export default {
  name: "app",
  components: {
    bottom,
    headerd,
    goods,
    car
  }
};
</script>

<style>
.el-header{
  height: 100% !important;
}
#app,
body,
html {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
.el-main,.el-header,.el-footer{
padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/goods.vue